module.exports = __webpack_public_path__ + "assets/images/chevron.627156fa.svg";